// extracted by mini-css-extract-plugin
export default {"responsivePlaceholder":"NameGroup_responsivePlaceholder__H54JX"};